import {Routes} from '@angular/router';
import {AuthLayoutComponent} from "./auth-module/layout/auth-layout/auth-layout.component";
import {LoginComponent} from "./auth-module/pages/login/login.component";
import {PasswordForgottenComponent} from "./auth-module/pages/password-forgotten/password-forgotten.component";
import {PasswordResetComponent} from "./auth-module/pages/password-reset/password-reset.component";
import {DashboardLayoutComponent} from "./dashboard-module/layout/dashboard-layout/dashboard-layout.component";
import {HomeComponent} from "./dashboard-module/pages/home/home.component";
import {InvoiceComponent} from "./dashboard-module/pages/invoice/invoice.component";
import {CustomerSupportComponent} from "./dashboard-module/pages/customer-support/customer-support.component";
import {MyAccountComponent} from "./dashboard-module/pages/my-account/my-account.component";
import {ChooseRelationComponent} from "./auth-module/pages/choose-relation/choose-relation.component";
import {TicketsComponent} from "./dashboard-module/pages/tickets/tickets.component";
import {TicketDetailComponent} from "./dashboard-module/pages/tickets/ticket-detail/ticket-detail.component";
import {loggedInGuard} from "./shared-module/guards/logged-in.guard";
import {
  BreakdownandmaintenanceComponent
} from "./dashboard-module/pages/breakdownandmaintenance/breakdownandmaintenance.component";
import {SubscriptionComponent} from "./dashboard-module/pages/subscription/subscription.component";
import {TicketNewComponent} from "./dashboard-module/pages/tickets/ticket-new/ticket-new.component";
import {
  RelationContactHasNotReachedMaximumTicketsGuard
} from "./shared-module/guards/relation-contact-has-not-reached-maximum-tickets.guard";
import {OrderProductPageComponent} from "./dashboard-module/pages/order-product-page/order-product-page.component";
import {selectedRelationGuard} from "./shared-module/guards/selected-relation.guard";
import {
  relationContactCanViewSelectedTicketGuard
} from "./shared-module/guards/relation-contact-can-view-selected-ticket.guard";
import {allScopeGuard} from "./shared-module/guards/all-scope.guard";
import {SurveyThanksComponent} from "./dashboard-module/pages/survey/thanks/thanks.component";
import {SurveyLandingComponent} from "./dashboard-module/pages/survey/landing/landing.component";
import {SurveyQuestionsComponent} from "./dashboard-module/pages/survey/questions/questions.component";
import {
  relationContactCanViewSelectedSurveyGuard
} from "./shared-module/guards/relation-contact-can-view-selected-survey.guard";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    title: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
        data: {
          showHeader: true,
        }
      },
      {
        path: 'password-forgotten',
        component: PasswordForgottenComponent,
        data: {
          showHeader: true,
        }
      },
      {
        path: 'password-reset',
        component: PasswordResetComponent,
        data: {
          showHeader: false,
        }
      },
      {
        path: 'change-password',
        component: PasswordResetComponent,
        data: {
          showHeader: false,
        }
      },
      {
        path: 'choose-relation',
        component: ChooseRelationComponent,
        data: {
          showHeader: true
        },
        canActivate: [
          loggedInGuard
        ]
      }
    ]
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [
      loggedInGuard,
      selectedRelationGuard,
    ],
    children: [
      {
        path: '',
        component: HomeComponent,
        data: {
          title: 'Overzicht',
          subtitle: 'Welkom bij ${appName}',
        },
        canActivate: [
          allScopeGuard
        ],
      },
      {
        path: 'subscription',
        component: SubscriptionComponent,
        data: {
          title: 'Abonnement',
          subtitle: 'Bekijk hier jouw abonnement(en)'
        },
        canActivate: [
          allScopeGuard
        ],
      },
      {
        path: 'order',
        component: OrderProductPageComponent,
        data: {
          title: 'Bestellen',
          subtitle: 'Voeg eenvoudig een nieuw product aan je abonnement toe en bekijk welke producten in aanvraag zijn.',
        },
        canActivate: [
          allScopeGuard
        ],
      },
      {
        path: 'invoice',
        data: {
          title: 'Facturen',
          subtitle: 'Bekijk hier je facturen'
        },
        children: [
          {
            path: '',
            component: InvoiceComponent,
          }
        ],
        canActivate: [
          allScopeGuard
        ],
      },
      {
        path: 'customersupport',
        children: [
          {
            path: '',
            component: CustomerSupportComponent,
            data: {
              title: 'Klantenservice',
              subtitle: 'Hulp nodig? ${companyName} helpt je graag verder.'
            },
            canActivate: [
              allScopeGuard
            ],
          },
          {
            path: 'tickets',
            children: [
              {
                path: '',
                component: TicketsComponent,
                data: {
                  title: 'Meldingen',
                  subtitle: 'Stuur een bericht via ${appName}',
                  showBackButton: true
                },
                canActivate: [
                  allScopeGuard
                ],
              },
              {
                path: 'new',
                component: TicketNewComponent,
                data: {
                  title: 'Nieuwe melding',
                  subtitle: 'Heb je een vraag of wil je een probleem melden? Stuur een bericht.',
                  showBackButton: true
                },
                canActivate: [
                  allScopeGuard,
                  RelationContactHasNotReachedMaximumTicketsGuard,
                ]
              },
              {
                path: ':id',
                component: TicketDetailComponent,
                canActivate: [
                  relationContactCanViewSelectedTicketGuard,
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'myaccount',
        component: MyAccountComponent,
        data: {
          title: 'Mijn gegevens',
          subtitle: 'Bekijk hier jouw gegevens.'
        },
        canActivate: [
          allScopeGuard
        ],
      },
      {
        path: 'surveys',
        data: {
          title: 'Enquête',
        },
        children: [
          {
            path: ':id/thanks',
            component: SurveyThanksComponent,
            data: {
              subtitle: 'Bedankt voor jouw mening.',
              showBackButton: false
            },
            canActivate: [
              relationContactCanViewSelectedSurveyGuard
            ],
          },
          {
            path: ':id/:position',
            component: SurveyQuestionsComponent,
            data: {
              subtitle: 'Vragen',
              showBackButton: false
            },
            canActivate: [
              relationContactCanViewSelectedSurveyGuard
            ],
          },
          {
            path: ':id',
            component: SurveyLandingComponent,
            data: {
              showBackButton: false
            },
            canActivate: [
              relationContactCanViewSelectedSurveyGuard
            ],
          }
        ],
      },
      {
        path: 'breakdownandmaintenance',
        component: BreakdownandmaintenanceComponent,
        data: {
          title: 'Storingen en onderhoud',
          subtitle: 'Bekijk of er storingen of onderhoudsbeurten plaatsvinden in jouw omgeving.',
          showBackButton: true
        },
        canActivate: [
          allScopeGuard
        ],
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
